<template>
  <section id="inicio" class="bg azulMuyClaro">
    <div>
      <v-container id="container">
        <v-row
          justify="center"
          align="center"
          style="min-height: 90vh"
          class="pt-15"
        >
          <v-col cols="12">
            <v-row class="d-flex justify-center">
              <v-col
                cols="9"
                md="5"
                xl="6"
                align-self="center"
                justify="center"
                class="py-10"
              >
                <p
                  id="titulo"
                  v-scrollanimation
                  class="neftysBlue--text text-h4 text-md-h3 text-xl-h2 mb-4"
                >
                  {{ $t("mensaje") }}
                </p>
                <p v-scrollanimation class="neftysBlue--text headline">
                  {{ $t("definicion") }}
                </p>
                <v-dialog width="80%">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex justify-center justify-md-start" style="display: none !important">
                      <v-btn
                        v-scrollanimation
                        color="accent"
                        class="btn mt-5"
                        rounded
                      >
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="playBut d-flex align-center"
                        >
                          <a class="">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
                              x="0px"
                              y="0px"
                              width="20px"
                              height="40px"
                              viewBox="50 0 100 200"
                              enable-background="new 0 0 200 200"
                              xml:space="preserve"
                            >
                              <polygon
                                class="triangle"
                                id="XMLID_18_"
                                fill="none"
                                stroke-width="7"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                points="73.5,62.5 148.5,105.8 73.5,149.1 "
                              />

                              <!-- <circle
                            class="circle"
                            id="XMLID_17_"
                            fill="none"
                            stroke-width="7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            cx="106.8"
                            cy="106.8"
                            r="103.3"
                          /> -->
                            </svg>
                          </a>
                          <p class="white--text subheading ml-2 mb-0">
                            {{ $t("video") }}
                          </p>
                        </div>
                      </v-btn>
                    </div>
                  </template>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="5" xl="6" class="mb-10 mb-md-0 pa-0">
                <v-img
                  class="mt-md-15"
                  src="@/assets/img/neftys/veterinaris.png"
                  contain
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="start" class="flecha">
          <v-col cols="12" class="d-flex justify-center">
            <div color="transparent" class="arrow d-flex justify-center">
              <svg
                id="Icon"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
              >
                <rect
                  id="Area"
                  width="40"
                  height="40"
                  fill="#fcfcfc"
                  opacity="0"
                />
                <g
                  id="Icon-2"
                  data-name="Icon"
                  transform="translate(9.905 14.858)"
                  class="secondary"
                >
                  <path
                    id="Path"
                    d="M5,7.5l9.905,9.905L24.811,7.5"
                    transform="translate(-5 -7.5)"
                    fill="none"
                    stroke="#3d3d3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="4"
                  />
                </g>
              </svg>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "Landing",
  data() {
    return {
      dialog: false,
      isActive: false,
      cajon: true,
    };
  },
};
</script>

<style scoped>
section {
  min-height: 100vh;
}

.bg {
  background: url(../../../assets/img/fondo_home_neftys_sd.svg) center bottom no-repeat;
  background-size: cover;
}

#container {
  min-height: 100vh;
}

.flecha {
  z-index: 10;
}

.arrow {
  width: 2rem;
  height: 4rem;
  border: 1px transparent #fff;
  border-radius: 1rem;
  z-index: 1;
}

.arrow svg {
  display: block;
  animation: arrow 1s ease-in-out infinite;
}

@keyframes arrow {
  0% {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  100% {
    opacity: 1;
    transform: translateY(1.5rem);
  }
}

h1.before-enter {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 0.5s ease-in-out;
}

h1.enter {
  opacity: 1;
  transform: translateX(0px);
}

p.before-enter {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 1s ease-in-out;
}

p.enter {
  opacity: 1;
  transform: translateX(0px);
}

.before-enter.btn {
  opacity: 0;

  transition: all 1.5s ease-in-out;
}

.enter.btn {
  opacity: 1;
}

.playBut {
  /* border: 1px solid red; */
  display: inline-block;
  transition: all 0.7s ease-in-out infinite;
}
.triangle {
  transition: all 0.7s ease-in-out;
  stroke-dasharray: 240;
  stroke-dashoffset: 480;
  stroke: #fff;
  transform: translateY(0);
}

.playBut:hover .triangle {
  stroke-dashoffset: 0;
  opacity: 1;
  stroke: #fff;
  animation: nudge 0.7s ease-in-out;
  fill: #fff;
}

@keyframes nudge {
  0% {
    transform: translateX(0);
  }
  30% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  70% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(0);
  }
}

/* aqui iria tb el .circle */
.btn:hover {
  stroke-dashoffset: 0;
  opacity: 1;
}
</style>
